import { render } from "./oasis-modal.vue?vue&type=template&id=5a8bc8cb"
import script from "./oasis-modal.vue?vue&type=script&lang=js"
export * from "./oasis-modal.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "5a8bc8cb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a8bc8cb', script)) {
    api.reload('5a8bc8cb', script)
  }
  
  module.hot.accept("./oasis-modal.vue?vue&type=template&id=5a8bc8cb", () => {
    api.rerender('5a8bc8cb', render)
  })

}

script.__file = "src/components/oasis-modal.vue"

export default script